import { Product } from '../../types/Product';
import { MenuOptions } from '../../types/Menu';
import { calculateNutritionalInfo } from './nutritionalInfo';

export const generateProductContext = (products: Product[]): string => {
  return products.map(product => {
    return `- ${product.display_name}:
  * Categoría: ${product.category_name}
  * Marca: ${product.brand}
  * Descripción: ${product.description}`;
  }).join('\n');
};

export const getDifficultyContext = (difficulty: string): string => {
  switch (difficulty) {
    case 'easy':
      return 'técnicas básicas de cocina, procesos simples y pocos pasos';
    case 'medium':
      return 'algunas técnicas intermedias, procesos moderados y pasos equilibrados';
    case 'hard':
      return 'técnicas avanzadas de cocina, procesos elaborados y múltiples pasos';
    default:
      return 'técnicas intermedias de cocina';
  }
};

export const getTimeContext = (cookingTime: string): string => {
  switch (cookingTime) {
    case 'quick':
      return '15-30 minutos';
    case 'medium':
      return '30-60 minutos';
    case 'elaborate':
      return 'más de 60 minutos';
    default:
      return '30-60 minutos';
  }
};

export const generateRecipePrompt = (
  products: Product[],
  menuName: string,
  options: MenuOptions
): string => {
  const productContext = generateProductContext(products);
  const difficultyContext = getDifficultyContext(options.difficulty);
  const timeContext = getTimeContext(options.cookingTime);
  const nutritionalInfo = options.showNutritionalInfo ? calculateNutritionalInfo(products) : '';

  return `Como chef experto, genera una receta detallada para "${menuName}" usando los siguientes ingredientes:

${productContext}

Especificaciones de la receta:
- Nivel de dificultad: ${difficultyContext}
- Tiempo de preparación estimado: ${timeContext}
${options.useThermomix ? '- Incluir instrucciones específicas para Thermomix' : ''}

La receta debe seguir esta estructura:

1. Preparación previa:
   - Lista de ingredientes con cantidades aproximadas
   - Utensilios necesarios
   - Consejos de preparación inicial

2. ${options.useThermomix ? 'Pasos para Thermomix:' : 'Proceso de elaboración:'}
   - Pasos detallados y ordenados
   - Tiempos específicos para cada paso
   - Temperaturas cuando sean relevantes
   ${options.useThermomix ? '- Velocidades y tiempos específicos del Thermomix' : ''}

3. Emplatado y presentación:
   - Sugerencias de montaje
   - Decoración
   - Temperatura de servido

${nutritionalInfo}

${options.showAlternatives ? `
4. Alternativas y variaciones:
   - Sugerencias de ingredientes alternativos
   - Adaptaciones para diferentes dietas
   - Variaciones de la receta` : ''}`;
};